let countiesMapGrid = $('.counties-map--grid');
if (countiesMapGrid.length) {
  $(window).on('scroll', function () {
    stickyCountiesMap();
  });

  $(window).on('load', function () {
    stickyCountiesMap();

    let content = document.querySelector('.counties-map--grid');
    let config = {
      subtree: true,
      childList: true,
    };
    let observer = new MutationObserver(function (mutations) {
      stickyCountiesMap();
    });
    let observer1 = new window.ResizeObserver(function () {
      stickyCountiesMap();
    });
    observer.observe(content, config);
    observer1.observe(content);
  });

  // let bodyWidth = window.innerWidth;
  $(window).on('resize', function () {
    stickyCountiesMap();
    // if (bodyWidth !== window.innerWidth) {
    //   bodyWidth = window.innerWidth;
    // }
  });

  function stickyCountiesMap() {
    let header = $('.header');
    let content = countiesMapGrid;
    let fixed = $('.counties-map--map--inner');
    let countiesMapMap = $('.counties-map--map');
    let scrollValue = content.position().top - header.outerHeight();
    let fixedPosition = header.outerHeight();

    stickyCountiesMapScroll();

    fixed.css('width', '100%');
    fixed.css('width', countiesMapMap.outerWidth() + 'px');

    function stickyCountiesMapScroll() {
      if (window.innerWidth >= 768) {
        let scroll = $(window).scrollTop();
        if (scroll >= scrollValue) {
          fixed.addClass('is-fixed');
          fixed.css('top', fixedPosition + 'px');
        } else {
          fixed.removeClass('is-fixed');
        }
        if (
          scroll >=
          countiesMapMap.position().top +
            countiesMapMap.outerHeight() -
            fixed.outerHeight() -
            fixedPosition
        ) {
          fixed.addClass('is-relative');
          fixed.css(
            'top',
            countiesMapMap.outerHeight() - fixed.outerHeight() + 'px'
          );
        } else {
          fixed.removeClass('is-relative');
        }
      }
    }
  }
  document.querySelectorAll('#svg-counties-map > g').forEach((e) => {
    $(e).bind('click', function () {
      let districtId = $(this).data('district-id');
      $('.counties-map-' + districtId).each(function () {
        let opened = this.classList.contains('is-open');
        document.querySelectorAll('.js-toggle-accordion').forEach((e) => {
          e.classList.remove('is-open');
        });

        document
          .querySelectorAll('.js-toggle-accordion [class*="--content"]')
          .forEach((e) => (e.style.maxHeight = null));

        if (opened) {
          this.classList.remove('is-open');
        } else {
          this.classList.add('is-open');
        }

        let text = this.querySelector('[class*="--content"]');
        if (opened) {
          text.style.maxHeight = null;
        } else {
          setTimeout(function () {
            text.style.maxHeight = text.scrollHeight + 'px';
          }, 300);
        }
        let ids = $(this).data('ids');
        if (Number.isInteger(ids)) {
          let currEl = document.querySelector('#svg-counties-map-' + (ids - 1));
          currEl.classList.add('is-active');
          document.querySelectorAll('#svg-counties-map > g').forEach((e) => {
            let regionMapId = $(e).data('district-id');
            if (ids !== regionMapId || opened) {
              e.classList.remove('is-active');
            }
          });
        } else {
          ids.split(',').forEach(function (id) {
            let currEl = document.querySelector(
              '#svg-counties-map-' + (id - 1)
            );
            currEl.classList.add('is-active');
            document.querySelectorAll('#svg-counties-map > g').forEach((e) => {
              let regionMapId = $(e).data('district-id');
              if (!ids.includes(String(regionMapId)) || opened) {
                e.classList.remove('is-active');
              }
            });
          });
        }
      });
    });
  });
}

function toggleCounties(ids, regionId, initialBoot = false) {
  const arrIds = ids.split(',');
  let elem = document.querySelector('#' + regionId);
  if (elem) {
    let opened = elem.classList.contains('is-open');
    document.querySelectorAll('.js-toggle-accordion').forEach((e) => {
      e.classList.remove('is-open');
    });

    document
      .querySelectorAll('.js-toggle-accordion [class*="--content"]')
      .forEach((e) => (e.style.maxHeight = null));

    if (opened) {
      elem.classList.remove('is-open');
    } else {
      elem.classList.add('is-open');
    }

    let text = elem.querySelector('[class*="--content"]');
    if (opened) {
      text.style.maxHeight = null;
    } else {
      setTimeout(function () {
        text.style.maxHeight = text.scrollHeight + 'px';
      }, 300);
    }

    if (!initialBoot) {
      setTimeout(function () {
        const headerHeight = document.querySelector('.header').offsetHeight;
        let y = elem.getBoundingClientRect().top + window.scrollY;
        y -= headerHeight;
        window.scroll({
          top: y,
          behavior: 'smooth',
        });
      }, 300);
    }

    arrIds.forEach(function (id, index, arr) {
      let elemMap = document.querySelector('#svg-counties-map-' + (id - 1));

      let openedMap = elemMap.classList.contains('is-active');
      document.querySelectorAll('#svg-counties-map > g').forEach((e) => {
        let regionMapId = $(e).data('district-id');
        if (!arr.includes(String(regionMapId))) {
          e.classList.remove('is-active');
        }
      });

      if (openedMap) {
        elemMap.classList.remove('is-active');
      } else {
        elemMap.classList.add('is-active');
      }
    });
  }
}
toggleCounties('0', 'counties-map-0', true);
